import { Component, Input, Output, EventEmitter } from "@angular/core";
import Swal from "sweetalert2";

export interface ConfirmationModalOptions {
  title?: string;
  subtitle?: string;
  description?: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  icon?: "warning" | "success" | "error" | "info" | "question";
  iconType?: "alert" | "success" | "danger" | "info" | "question";
}

@Component({
  selector: "app-confirmation-modal",
  templateUrl: "./confirmation-modal.component.html",
  styleUrls: ["./confirmation-modal.component.scss"],
})
export class ConfirmationModalComponent {
  @Input() title = "Deseja excluir essa configuração?";
  @Input() subtitle = "";
  @Input() description =
    "Essa ação não poderá ser desfeita. Tem certeza que deseja excluir essa configuração?";
  @Input() confirmButtonText = "SIM, EXCLUIR";
  @Input() cancelButtonText = "VOLTAR";
  @Input() icon: "warning" | "success" | "error" | "info" | "question" =
    "warning";
  @Input() iconType: "alert" | "success" | "danger" | "info" | "question" =
    "danger";
  @Input() showModal = false;

  @Output() confirmed = new EventEmitter<boolean>();
  @Output() cancelled = new EventEmitter<boolean>();

  showConfirmationModal(options?: ConfirmationModalOptions): void {
    const title = options?.title || this.title;
    const subtitle = options?.subtitle || this.subtitle;
    const description = options?.description || this.description;
    const confirmButtonText =
      options?.confirmButtonText || this.confirmButtonText;
    const cancelButtonText = options?.cancelButtonText || this.cancelButtonText;
    const iconType = options?.iconType || this.iconType;

    let swalIcon: "warning" | "success" | "error" | "info" | "question" =
      "warning";
    if (iconType === "success") swalIcon = "success";
    else if (iconType === "danger") swalIcon = "error";
    else if (iconType === "info") swalIcon = "info";
    else if (iconType === "question") swalIcon = "question";
    else swalIcon = "warning";

    const htmlContent = subtitle
      ? `<div class="swal-subtitle">${subtitle}</div><div class="swal-description">${description}</div>`
      : description;

    const showIcon = iconType !== "question";
    const popupClass =
      iconType === "question"
        ? "swal-confirmation-popup swal-question-modal"
        : "swal-confirmation-popup";

    const swalResult = Swal.fire({
      title: title,
      html: htmlContent,
      icon: showIcon ? swalIcon : undefined,
      showCancelButton: true,
      confirmButtonText: confirmButtonText,
      cancelButtonText: cancelButtonText,
      customClass: {
        popup: popupClass,
        title: "swal-confirmation-title",
        htmlContainer: "swal-confirmation-content",
        confirmButton: "swal-confirmation-confirm-btn",
        cancelButton: "swal-confirmation-cancel-btn",
        icon: `swal-confirmation-icon swal-confirmation-icon-${iconType}`,
      },
      buttonsStyling: false,
      reverseButtons: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
    });

    setTimeout(() => {
      const confirmBtn = document.querySelector(
        ".swal2-confirm",
      ) as HTMLElement;
      const cancelBtn = document.querySelector(".swal2-cancel") as HTMLElement;
      const iconElement = document.querySelector(".swal2-icon") as HTMLElement;
      const popupElement = document.querySelector(
        ".swal2-popup",
      ) as HTMLElement;
      const containerElement = document.querySelector(
        ".swal2-container",
      ) as HTMLElement;

      if (iconType === "question") {
        if (containerElement) {
          containerElement.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
          containerElement.style.backdropFilter = "blur(4px)";
        }

        if (popupElement) {
          popupElement.style.width = "480px";
          popupElement.style.minHeight = "280px";
          popupElement.style.padding = "2rem 2.5rem";
          popupElement.style.borderRadius = "8px";
          popupElement.style.boxShadow = "0 4px 24px rgba(0, 0, 0, 0.15)";
        }

        // Botão CANCELAR - cinza filled
        if (cancelBtn) {
          cancelBtn.style.height = "40px";
          cancelBtn.style.minWidth = "110px";
          cancelBtn.style.padding = "0 1.5rem";
          cancelBtn.style.fontSize = "0.75rem";
          cancelBtn.style.fontWeight = "600";
          cancelBtn.style.borderRadius = "4px";
          cancelBtn.style.margin = "0";
          cancelBtn.style.letterSpacing = "0.5px";
          cancelBtn.style.backgroundColor = "var(--bs-body-color) !important";
          cancelBtn.style.border = "none";
          cancelBtn.style.color = "#ffffff";
          cancelBtn.style.textTransform = "uppercase";
        }

        // Botão APROVAR - filled azul
        if (confirmBtn) {
          confirmBtn.style.height = "40px";
          confirmBtn.style.minWidth = "110px";
          confirmBtn.style.padding = "0 1.5rem";
          confirmBtn.style.fontSize = "0.75rem";
          confirmBtn.style.fontWeight = "600";
          confirmBtn.style.borderRadius = "4px";
          confirmBtn.style.margin = "0";
          confirmBtn.style.letterSpacing = "0.5px";
          confirmBtn.style.backgroundColor = "var(--primary-color) !important";
          confirmBtn.style.border = "none";
          confirmBtn.style.color = "#ffffff";
          confirmBtn.style.textTransform = "uppercase";
        }

        // Área dos botões
        const actionsElement = document.querySelector(
          ".swal2-actions",
        ) as HTMLElement;
        if (actionsElement) {
          actionsElement.style.gap = "0.75rem";
          actionsElement.style.marginTop = "0";
        }

        // Título
        const titleElement = document.querySelector(
          ".swal2-title",
        ) as HTMLElement;
        if (titleElement) {
          titleElement.style.fontSize = "1rem";
          titleElement.style.fontWeight = "600";
          titleElement.style.color = "#9E9E9E";
          titleElement.style.marginBottom = "0.75rem";
          titleElement.style.textTransform = "none";
        }

        // Conteúdo
        const htmlContainer = document.querySelector(
          ".swal2-html-container",
        ) as HTMLElement;
        if (htmlContainer) {
          htmlContainer.style.marginBottom = "1.5rem";
        }

        // Subtitle
        const subtitleElement = document.querySelector(
          ".swal-subtitle",
        ) as HTMLElement;
        if (subtitleElement) {
          subtitleElement.style.fontSize = "1.375rem";
          subtitleElement.style.fontWeight = "500";
          subtitleElement.style.color = "#9E9E9E";
          subtitleElement.style.marginBottom = "0.5rem";
          subtitleElement.style.textTransform = "uppercase";
          subtitleElement.style.lineHeight = "1.3";
        }

        // Description
        const descriptionElement = document.querySelector(
          ".swal-description",
        ) as HTMLElement;
        if (descriptionElement) {
          descriptionElement.style.fontSize = "0.875rem";
          descriptionElement.style.color = "#757575";
          descriptionElement.style.marginBottom = "0";
          descriptionElement.style.lineHeight = "1.4";
        }
      } else {
        // Estilos para outros tipos de modal
        if (popupElement) {
          popupElement.style.width = "600px";
        }

        if (confirmBtn) {
          confirmBtn.style.backgroundColor = "#ffffff";
          confirmBtn.style.fontWeight = "600";
          confirmBtn.style.textTransform = "uppercase";
          confirmBtn.style.borderRadius = "4px";
          confirmBtn.style.padding = "0.75rem 1.5rem";
          confirmBtn.style.minWidth = "120px";
          confirmBtn.style.border = "1px solid";
          confirmBtn.style.marginLeft = "12px";

          // Aplicar cores baseadas no tipo
          if (iconType === "danger") {
            confirmBtn.style.borderColor =
              "var(--bs-danger-border-subtle) !important";
            confirmBtn.style.color =
              "var(--bs-danger-text-emphasis) !important";
          } else if (iconType === "success") {
            confirmBtn.style.borderColor =
              "var(--bs-success-border-subtle) !important";
            confirmBtn.style.color =
              "var(--bs-success-text-emphasis) !important";
          } else if (iconType === "info") {
            confirmBtn.style.borderColor =
              "var(--bs-info-border-subtle) !important";
            confirmBtn.style.color = "var(--bs-info-text-emphasis) !important";
          } else {
            confirmBtn.style.borderColor =
              "var(--bs-warning-border-subtle) !important";
            confirmBtn.style.color =
              "var(--bs-warning-text-emphasis) !important";
          }
        }

        if (cancelBtn) {
          cancelBtn.style.backgroundColor = "var(--secondary-color) !important";
          cancelBtn.style.border =
            "2px solid var(--secondary-color) !important";
          cancelBtn.style.color = "#ffffff";
          cancelBtn.style.fontWeight = "600";
          cancelBtn.style.textTransform = "uppercase";
          cancelBtn.style.borderRadius = "6px";
          cancelBtn.style.padding = "0.75rem 1.5rem";
          cancelBtn.style.minWidth = "120px";
          cancelBtn.style.marginRight = "12px";
        }
      }

      if (iconElement && iconType !== "question") {
        let svgIcon = "";

        if (iconType === "danger") {
          svgIcon = `
            <svg xmlns="http://www.w3.org/2000/svg" width="104" height="104" viewBox="0 0 104 104" fill="none">
              <path d="M56.333 73.6673L47.6663 73.6673L47.6663 65.0007L56.333 65.0007L56.333 73.6673ZM56.333 56.334L47.6663 56.334L47.6663 30.334L56.333 30.334L56.333 56.334ZM51.9997 95.334C75.9197 95.334 95.333 75.9207 95.333 52.0007C95.333 28.0807 75.9197 8.66732 51.9997 8.66732C28.0797 8.66732 8.66634 28.0807 8.66634 52.0007C8.66634 75.9207 28.0797 95.334 51.9997 95.334ZM51.9997 17.334C71.1097 17.334 86.6663 32.8907 86.6663 52.0007C86.6663 71.1107 71.1097 86.6673 51.9997 86.6673C32.8897 86.6673 17.333 71.1107 17.333 52.0007C17.333 32.8907 32.8897 17.334 51.9997 17.334Z" fill="#F44336"/>
            </svg>
          `;
        } else if (iconType === "success") {
          svgIcon = `
            <svg xmlns="http://www.w3.org/2000/svg" width="104" height="104" viewBox="0 0 104 104" fill="none">
              <path d="M43.333 65.0007L30.333 52.0007L25.6663 56.6673L43.333 74.334L78.333 39.334L73.6663 34.6673L43.333 65.0007ZM51.9997 95.334C75.9197 95.334 95.333 75.9207 95.333 52.0007C95.333 28.0807 75.9197 8.66732 51.9997 8.66732C28.0797 8.66732 8.66634 28.0807 8.66634 52.0007C8.66634 75.9207 28.0797 95.334 51.9997 95.334ZM51.9997 17.334C71.1097 17.334 86.6663 32.8907 86.6663 52.0007C86.6663 71.1107 71.1097 86.6673 51.9997 86.6673C32.8897 86.6673 17.333 71.1107 17.333 52.0007C17.333 32.8907 32.8897 17.334 51.9997 17.334Z" fill="#4CAF50"/>
            </svg>
          `;
        } else if (iconType === "info") {
          svgIcon = `
            <svg xmlns="http://www.w3.org/2000/svg" width="104" height="104" viewBox="0 0 104 104" fill="none">
              <path d="M47.6663 73.6673L56.333 73.6673L56.333 47.6673L47.6663 47.6673L47.6663 73.6673ZM47.6663 39.334L56.333 39.334L56.333 30.334L47.6663 30.334L47.6663 39.334ZM51.9997 95.334C75.9197 95.334 95.333 75.9207 95.333 52.0007C95.333 28.0807 75.9197 8.66732 51.9997 8.66732C28.0797 8.66732 8.66634 28.0807 8.66634 52.0007C8.66634 75.9207 28.0797 95.334 51.9997 95.334ZM51.9997 17.334C71.1097 17.334 86.6663 32.8907 86.6663 52.0007C86.6663 71.1107 71.1097 86.6673 51.9997 86.6673C32.8897 86.6673 17.333 71.1107 17.333 52.0007C17.333 32.8907 32.8897 17.334 51.9997 17.334Z" fill="#2196F3"/>
            </svg>
          `;
        }

        if (svgIcon) {
          iconElement.innerHTML = svgIcon;
          iconElement.style.border = "none";
          iconElement.style.background = "none";
        }
      }
    }, 100);

    swalResult.then((result) => {
      if (result.isConfirmed) {
        this.confirmed.emit(true);
      } else if (result.isDismissed) {
        this.cancelled.emit(true);
      }
    });
  }

  // Método para ser chamado externamente - aceita parâmetros opcionais
  public openModal(options?: ConfirmationModalOptions): void {
    this.showConfirmationModal(options);
  }
}
